/* eslint no-console: 0 */
// Run this example by adding <%= javascript_pack_tag 'hello_vue' %> (and
// <%= stylesheet_pack_tag 'hello_vue' %> if you have styles in your component)
// to the head of your layout file,
// like app/views/layouts/application.html.erb.
// All it does is render <div>Hello Vue</div> at the bottom of the page.

// import logger from './logger.js'
// logger.disableLogger();

import { Vue, settings, vueApp, useGlibErrorReporter } from 'glib-web/index.js'
import './firebase.js'

// import UrlFragmentField from "./custom/templates/urlFragmentField.vue";
// Vue.component("template-urlFragmentField", UrlFragmentField);

// Report browser-side JS errors (Vue, glib actions, window errors, unhandled
// promise rejections) to POST /glib/errors, which forwards them to Rollbar
// server-side. The reporter dedupes per page load and caps volume; Rollbar's
// environment gating (disabled in test, no token in development) decides
// actual delivery.
useGlibErrorReporter()

settings.themes = {
  light: {
    dark: false,
    colors: {
      primary: "#1A4D6A",
      success: "#34BE4D",
      error: "#F13327",
      warning: "#FFA500",
      info: "#379FD7",
      // info: "#33B5E7"

      // green: "#FF5D6D"
    }
    // // primary: "#2b95ac",
    // primary: "#379FD7",
    // // warning: "#fb8c00",
    // warning: "#ff0000",
    // info: "379FD7"
  }
};

// Vuetify 4 defaults the theme to the visitor's OS colour scheme ("system");
// the app only ships a light design, so visitors in OS dark mode would get
// dark Vuetify surfaces under our light-only chrome. Pin light until a real
// dark theme exists.
import vuetify from "glib-web/plugins/vuetify.js";
vuetify.theme.change("light");

// Custom templates
import Captcha from "./custom/templates/captcha.vue";
Vue.component("template-captcha", Captcha);

import ChatWidget from "./custom/templates/chat/widget.vue";
Vue.component("template-chat-widget", ChatWidget);
